//shared/components/chat/ChatSidebar.js
import React from "react";
import {
  Paper,
  List,
  ListItem,
  ListItemButton,
  ListItemAvatar,
  ListItemText,
  Avatar,
  Badge,
  Typography,
  Divider,
  Box,
  CircularProgress,
} from "@mui/material";
import SmartToyIcon from "@mui/icons-material/SmartToy";

import { formatDistanceToNow } from "date-fns";
import { ptBR } from "date-fns/locale";

const ChatSidebar = ({ conversations, selectedId, onSelect, loading }) => {
  const formatTime = (date) => {
    return formatDistanceToNow(new Date(date), {
      addSuffix: true,
      locale: ptBR,
    });
  };

  return (
    <Paper
      sx={{
        width: 280,
        borderRight: 1,
        borderColor: "divider",
        overflow: "auto",
        height: "100%",
      }}
      elevation={0}
    >
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
          <CircularProgress size={24} />
        </Box>
      ) : (
        <List sx={{ p: 0 }}>
          {conversations.map((conv, index) => (
            <React.Fragment key={conv.id}>
              <ListItem disablePadding>
                <ListItemButton
                  selected={selectedId === conv.id}
                  onClick={() => onSelect(conv)}
                >
                  <ListItemAvatar>
                    <Badge
                      badgeContent={conv.unreadCount}
                      color="error"
                      overlap="circular"
                    >
                      {conv.isAI ? (
                        <Avatar
                          sx={{
                            bgcolor: "#ccc",
                            padding: "3px",
                            "& img": {
                              objectFit: "contain",
                              imageRendering: "auto",
                            },
                          }}
                          src="/images/dentinhoCutNoBg.png"
                        >
                          Dentinho
                        </Avatar>
                      ) : (
                        <Avatar
                          src={
                            conv.user?.avatar
                              ? `${process.env.REACT_APP_BACKEND_LINK}/${conv.user.avatar}`
                              : null
                          }
                        >
                          {conv.user?.name?.[0]?.toUpperCase()}
                        </Avatar>
                      )}
                    </Badge>
                  </ListItemAvatar>

                  <ListItemText
                    primary={
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                      >
                        <Typography
                          variant="subtitle1"
                          fontWeight={conv.unreadCount > 0 ? 600 : 400}
                        >
                          {conv.user?.name || "Utilizador"}
                        </Typography>
                        {conv.isAI && (
                          <Typography
                            variant="caption"
                            sx={{
                              bgcolor: "secondary.main",
                              color: "white",
                              px: 0.5,
                              borderRadius: 0.5,
                              fontSize: "0.65rem",
                            }}
                          >
                            IA
                          </Typography>
                        )}
                      </Box>
                    }
                    secondary={
                      <Box>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          noWrap
                          sx={{
                            fontWeight: conv.unreadCount > 0 ? 500 : 400,
                            fontStyle: conv.lastMessage ? "normal" : "italic",
                          }}
                        >
                          {conv.lastMessage?.text ||
                            "Clique para iniciar conversa"}
                        </Typography>
                        {conv.lastMessage?.createdAt && (
                          <Typography variant="caption" color="text.secondary">
                            {formatTime(conv.lastMessage.createdAt)}
                          </Typography>
                        )}
                      </Box>
                    }
                  />
                </ListItemButton>
              </ListItem>
              {index < conversations.length - 1 && <Divider />}
            </React.Fragment>
          ))}

          {conversations.length === 0 && (
            <Box sx={{ p: 4, textAlign: "center" }}>
              <Typography color="text.secondary">
                Nenhum usuário disponível
              </Typography>
            </Box>
          )}
        </List>
      )}
    </Paper>
  );
};

export default ChatSidebar;
